import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=b2c431c4&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "../assets/stylesheets/Settings.css?vue&type=style&index=0&id=b2c431c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c431c4",
  null
  
)

export default component.exports